import { SourceTypes } from '../../../../constants';
import {
  getDataServiceExcludeContentFilters,
  getDataServicePage,
  getDataServicePostsFetcher,
  getDataServicePostsSelector,
  getPostsURL,
  getSourceStatusURL
} from '../../utils';
import type { ProviderType } from '../types';
import type { InstagramResponseType, InstagramSourceValue } from './types';
import { instagramExcludeFiltersKeys } from './utils';

const PLATFORM = SourceTypes.INSTAGRAM;

export function createInstagramHashtagProvider(
  sourceValue: InstagramSourceValue,
  globalKey: string[],
  filtersKey: string[],
  widgetToken: string
): ProviderType<InstagramResponseType> {
  const {
    source = '',
    sourcePID = '',
    authentication,
    status,
    _customWidgetDataPostsLimit
  } = sourceValue;
  const excludeFilters = getDataServiceExcludeContentFilters(
    sourceValue,
    instagramExcludeFiltersKeys
  );
  const excludeFiltersKey = JSON.stringify(excludeFilters);
  const key = [
    ...globalKey,
    ...filtersKey,
    source,
    excludeFiltersKey,
    status,
    authentication?.status ?? ''
  ];

  const statusURL = getSourceStatusURL(sourcePID);

  const postsURL = getPostsURL({
    sourcePID,
    filters: excludeFilters,
    limit: _customWidgetDataPostsLimit
  });

  const page = getDataServicePage(postsURL);

  const select = getDataServicePostsSelector({
    platform: PLATFORM,
    shouldUseUsername: true
  });

  const customFetch = getDataServicePostsFetcher({
    status,
    statusURL,
    postsURL,
    widgetToken,
    platform: PLATFORM
  });

  return { key, select, fetch: customFetch, page };
}
